import gql from 'graphql-tag';

import type { BlogContent } from 'src/data/blog';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProjectBlogContentArgs, BackendQueryProjectArgs } from 'src/types/backend';

import { FRAGMENT_PROJECT_BLOG_CONTENT } from './schema';

const QUERY = gql`
  query ProjectBlogData($projectId: Int!, $draftIndex: ID!) {
    project(id: $projectId) {
      id

      blogContent(draftId: $draftIndex) {
        ...BlogPostBuilderContent
      }
    }
  }
  ${FRAGMENT_PROJECT_BLOG_CONTENT}
`;

type Variables = {
  projectId: BackendQueryProjectArgs['id'];
  draftIndex: BackendProjectBlogContentArgs['draftId'];
};

interface Options {
  abortSignal?: AbortSignal;
}

interface Result {
  id: ID;
  blogContent: BlogContent;
}

export const queryProjectBlogData = async (variables: Variables, options?: Options) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  return getSingleProp<Result>(result.data);
};
